module.exports = __webpack_public_path__ + "static/chopper-e4f7fdc02c785e13357ec7251613c71a.png";